export default function shouldDismissOnOutsideClick(
  event: MouseEvent | TouchEvent,
): boolean {
  const target = event.target;

  if (!(target instanceof Element)) {
    return true;
  }

  return !target.closest('[data-state]');
}
